import React from 'react'
import AuthWrapper from './AuthWrapper'
import Person from '../icons/Person'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { RootReducer } from '../redux/rootReducer'
import Logo from '../icons/Logo'
interface Props {
  withWrapper?: boolean
  withAuth?: boolean
  children: JSX.Element | JSX.Element[]
  customClass?: string
}

const Layout = (props: Props) => {
  const { withAuth = true, withWrapper = true } = props
  if (withAuth && withWrapper) {
    return (
      <AuthWrapper>
        <LayoutBase {...props} />
      </AuthWrapper>
    )
  }
  if (withWrapper) {
    return <LayoutBase {...props} />
  }
  return <div>{props.children}</div>
}

const LayoutBase = ({ children, customClass = '' }: Props) => {
  const firstName = useSelector((state: RootReducer) => state.tutorReducer.first_name)
  const lastName = useSelector((state: RootReducer) => state.tutorReducer.last_name)
  return (
    <div className={`font-sans ${customClass} min-h-screen bg-white`}>
      <div className="max-w-[80rem] mx-auto px-2 ml--2 mr--2">
        <header className="px-2 ml--2 mr--2 ">
          <div className="h-2" />
          <div className="flex justify-between items-center">
            <Link to="/">
              <div className="flex items-center">
                <div className="w-16 h-16 text-darkRed bg-slateGray rounded-full flex items-center justify-center p-2">
                  <Logo />
                </div>
              </div>
            </Link>
            <div className="flex items-center">
              <Link to="/user">
                <div className="flex justify-end items-center">
                  <div className="flex items-center">
                    <div className="w-8 h-8">
                      <Person />
                    </div>
                    <div className="w-2" />
                    <p className="text-18 font-semibold">
                      {firstName} {lastName}
                    </p>
                    <div />
                  </div>
                </div>
              </Link>
              <div className="w-4" />
              <button
                onClick={() => {
                  localStorage.clear()
                  window.location.href = '/'
                }}
                className="bg-slateGray px-4 py-2 rounded-md text-white text-14 font-semibold hover:bg-opacity-90">
                Logout
              </button>
            </div>
          </div>
          <div className="h-2" />
        </header>
        {children}
      </div>
    </div>
  )
}

export default Layout
